module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-2.2-WeightBasedBullying_FR-897519854d0ed8b3a8af93974623c533.pdf";